/**
 * Represents redux keys in the store which are updated
 * via user input and via the Google spreadsheet.
 */
export enum REDUX_KEY {
  AGENCY_NAME = 'agencyName',
  ADVERTISER_NAME = 'advertiserName',
  CAMPAIGN_NAME = 'campaignName',
  ADVERTISER_DISCOUNT = 'advertiserDiscount',
  CAMPAIGN_DURATIONS = 'campaignDurations',
  CAMPAIGN_LENGTH = 'campaignLength',
  CAMPAIGN_LENGTH_START_DATE = 'startDate',
  CAMPAIGN_LENGTH_END_DATE = 'endDate',
  CAMPAIGN_NOTES = 'campaignNotes',
  GROSS_BUDGET = 'grossBudget',
  TARGET_TARP = 'targetTarp',
  TARGET_IMPACT = 'targetImpact',
  DEMOGRAPHIC = 'demographic',
  PEAK_PERCENTAGE = 'peakPercentage',
  NETWORK_BREAKDOWN_PERCENTAGE = 'networkBreakdownPercentage',
  DAYS = 'days',
  SPREADSHEET = 'spreadsheet',
  PRICING = 'pricing',
  PEAK_LOADING = 'peakLoading',
  DURATION_LOADING = 'durationLoading',
  WEEKLY_PRICING = 'weeklyPricing',
  STATION = 'station',
  DAY_STRAT = 'dayStrat',
  USED_BUDGET = 'usedBudget',
  USED_TARPS = 'usedTarps',
  USED_IMPACTS = 'usedImpacts',
  SELECTED_MONTH = 'selectedMonth',
  EDIT_MODE = 'editMode',
  COMMENCING_DAY = 'commencingDay',
  AD_MIRRORING = 'adMirroring'
}

/**
 * Represents redux keys that are calculated based on user input.
 */
export enum REDUX_KEY_CALCULATED {
  BASE_CPT = 'baseCPT',
  BASE_CPM = 'baseCPM',
  PEAK_LOADING = 'peakLoading',
  STATION_LOADING = 'stationLoading',
  STATION_SELECTED_VALUES = 'stationSelectedValues',
  STATION_SELECTED_OPTIMIZED = 'stationSelectedOptimized',
  TOTAL_STATION_LOADING = 'loading',
  DAYS = 'days',
  FIB_LIB_LOADING = 'fiblibLoading',
  TOTAL_DAYS_LOADING = 'loading',
  TOTAL_LOADING = 'totalLoading',
  TOTAL_CPT = 'totalCPT',
  TOTAL_CPM = 'totalCPM',
  TOTAL_TARPS = 'totalTarps',
  AD_MIRRORING = 'adMirroring',
  IS_AD_MIRRORING_ENABLED = 'isAdMirroringEnabled',
  AD_MIRRORING_LOADING = 'adMirroringLoading'
}

export enum SELECTED_VALUES {
  PEAK = 'peak',
  FIBLIB = 'fiblib'
}

export enum TVNZ_NETWORK {
  ONE = 'one',
  TWO = 'two',
  DUKE = 'duke',
  LOADING = 'loading'
}
